import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {Container, Row, Col} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import {
  changeHandler,
  getPhoneNumbers,
  initData,
  setSelectedPhone,
  setIsExistPhone,
  setIsSelectedOption,
  addAttempt,
  validateExistPhone,
  validateNewPhones,
  initValidation,
  reportAnalytics,
  setPrettyNumData,
} from './ChoseNewOrExistingCellNumSlice';
import TextInput from '../../../Shared/TextInput/TextInput';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import Helper from '../../../../utilities/helper';
import {getRecaptchaToken} from '../../../../utilities/recaptcha/recaptcha';
import Lottie from 'react-lottie';
import Heart from '../../../../animations/heart.json';

const choseNewOrExistingCellNum = (props) => {
  const [isShowPhonesList, setIsShowPhoneList] = useState('0');
  const [isShowNewPhone, setIsShowNewPhone] = useState('1');

  let list = '';

  useExtendedEffect((runSideEffects) => {
    if (!runSideEffects()) {
      if (props.form.isSelectedOption) {
        refreshPhones();
      }
    }

    props.initValidation();
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      if (props.form.newPrettyPhones) {
        if (props.form.newPrettyPhones.length > 0) {
          props.reportAnalytics({
            eventCategory: 'cellular_newsale_process',
            eventAction: 'visibility_30',
            eventLabel: 'screen_20',
          });
        }
      }
    },
    [props.form.newPrettyPhones],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit && props.onSubmit == true) {
          if (props.form.isExistPhone) {
            props.showAppLoader();
            props.validateExistPhone({form: props.form, selectedProducts: props.selectedProducts});
          } else props.validateNewPhones(props.form);
        }
      }
    },
    [props.onSubmit],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.valid !== '') {
          props.onValid(props.form.valid);
          props.initValidation();
        }
      }
    },
    [props.form.valid],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        props.hideAppLoader();
        centerInput();
      }
    },
    [props.form.newPhones],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.errorObj != null) {
          props.hideAppLoader();
          props.onError(props.form.errorObj.errorId);
        }
      }
    },
    [props.form.errorObj],
  );

  const refreshPhones = async () => {
    const token = await getRecaptchaToken('chooseNum');

    if (token != undefined && token != null) {
      props.setSelectedPhone({selectedPhone: ''});
      props.getPhoneNumbers({
        captchaToken: token,
        regularNumbersCount: props.numbersCount.regularNumbersCount,
        prettyNumbersCount: props.numbersCount.prettyNumbersCount,
      });
      props.showAppLoader();
    } else {
      console.error('recaptcha error, token not exists');
    }
  };

  const handleOptionChange = async (val) => {
    props.initData({form: props.form});

    props.setIsSelectedOption({isSelectedOption: true});
    setIsShowNewPhone(false);
    setIsShowPhoneList(false);

    if (val) {
      props.reportAnalytics({
        eventCategory: 'cellular_newsale_process',
        eventAction: props.flowType == 'existsCustomer' ? 'click_9' : 'click_30',
        eventLabel: props.productsInfo.selectedProducts[0]?.name,
      });
      setIsShowPhoneList(true);
      props.setIsExistPhone({isExistPhone: true});

      const token = await getRecaptchaToken('chooseNum');

      if (token != undefined && token != null) {
        props.setSelectedPhone({selectedPhone: ''});
        props.getPhoneNumbers({
          captchaToken: token,
          regularNumbersCount: props.numbersCount.regularNumbersCount,
          prettyNumbersCount: 0,
        });
        props.showAppLoader();
      } else {
        console.error('recaptcha error, token not exists');
      }
    } else {
      props.reportAnalytics({
        eventCategory: 'cellular_newsale_process',
        eventAction: props.flowType == 'existsCustomer' ? 'click_10' : 'click_31',
        eventLabel: props.productsInfo.selectedProducts[0]?.name,
      });
      setIsShowNewPhone(true);
      props.showAppLoader();
      props.setIsExistPhone({isExistPhone: false});
      props.setSelectedPhone({selectedPhone: ''});

      const token = await getRecaptchaToken('chooseNum');

      if (token != undefined && token != null) {
        props.setSelectedPhone({selectedPhone: ''});
        props.getPhoneNumbers({
          captchaToken: token,
          regularNumbersCount: props.numbersCount.regularNumbersCount,
          prettyNumbersCount: props.numbersCount.prettyNumbersCount,
        });
        props.showAppLoader();
      }
    }
  };

  const handleChangePackage = () => {
    EpiContext.navigateTo(props.urlToChangePackage);
  };

  const insertAt = (str, sub, pos) => {
    return `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
  };

  const handleSelected = (phone, isPretty) => {
    let prettyPrice = parseFloat(props.prettyNumberPrice);
    if (isPretty && props.PrettyNumChosenCount == 0) {
      props.addTotalPriceOneTime(prettyPrice);
      props.setPrettyNumChosenCount(1);
      props.setRegularNumChosenReset(0);
    }
    if (!isPretty && props.RegularNumChosenCount == 0 && props.PrettyNumChosenCount == 1) {
      props.currentTotalPriceOneTime(props.totalPriceOneTime - prettyPrice);
      props.setRegularNumChosenCount(1);
      props.setPrettyNumChosenReset(0);
    }

    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: props.flowType == 'existsCustomer' ? 'click_12' : 'click_33',
      eventLabel: props.productsInfo.selectedProducts[0]?.name,
    });
    props.setSelectedPhone({selectedPhone: phone, isPrettyNum: isPretty});
  };

  const centerInput = () => {
    const input = document.querySelector(`input[name=currentPhone]`);

    if (input !== null) {
      input.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  return (
    <div className='container-fluid main'>
      <div className='chose-phone-number'>
        <Row>
          <Col ms={12}>
            <h1 className='main-title'>{props.title}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <h1 className='top-title'>{props.subTitle}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <p className='top-link'>{props.linkText}</p>
          </Col>
        </Row>
        <Row>
          <Col ms={12} style={{display: 'flex', padding: '0px'}}>
            <div className='button-wrapper'>
              <div
                role='button'
                tabIndex='0'
                onKeyPress={(e) => Helper.onKeyPress(e, handleOnChangeProductClick)}
                className={isShowPhonesList === true ? 'text-container-selected' : 'text-container'}
                onClick={() => handleOptionChange(true)}>
                <div> אני רוצה לנייד קו מחברה אחרת </div>
              </div>
            </div>

            {props.selectedPhoneIndex == 0 && (
              <div className='button-wrapper'>
                <div
                  role='button'
                  tabIndex='1'
                  onKeyPress={(e) => Helper.onKeyPress(e, handleOnChangeProductClick)}
                  className='text-container'
                  onClick={() => handleChangePackage()}>
                  <div> אני רוצה לשנות את החבילה שיש לי </div>
                </div>
              </div>
            )}

            <div className='button-wrapper'>
              <div
                role='button'
                tabIndex='2'
                onKeyPress={(e) => Helper.onKeyPress(e, handleOnChangeProductClick)}
                className={isShowNewPhone === true ? 'text-container-selected' : 'text-container'}
                onClick={() => handleOptionChange(false)}>
                <div> אני רוצה קו חדש </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col ms={12} className='pr-0 pl-0'>
            <br />
            <div className={isShowPhonesList === true && props.form.newPhones ? 'component-container' : 'hide-container'}>
              <p>איזה מספר אנחנו מניידים?</p>
              {props.form.newPhones ? (
                <div style={{paddingLeft: '15px', paddingRight: '15px'}}>
                  <TextInput
                    onFocus={(e) => centerInput()}
                    error={props.form.errors.currentPhone}
                    onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                    value={props.form.currentPhone}
                    name='currentPhone'
                    pattern='[0-9]*'
                    type='text'
                    placeholder='מספר טלפון'
                  />
                </div>
              ) : (
                ''
              )}
              {props.existPhoneMessage != '' ? (
                <div className='error-container'>
                  <div className='error'>
                    <span style={{fontWeight: 'bold'}}>המנוי הזה כבר חלק מהמשפחה</span>
                    <br />
                    אנחנו רואים שהמספר הזה כבר שייך ל{window.Config.brand_Name_HE},
                    <br />
                    כדאי לבדוק שזה המספר הנכון ולנסות שוב
                  </div>
                </div>
              ) : (
                ''
              )}
              <br />
              <br />
            </div>
          </Col>
        </Row>

        <div className={isShowNewPhone === true && props.form.newPhones ? 'component-container' : 'hide-container'}>
          <p> בחרו את המספר שאתם אוהבים </p>
          <p> אם לא מצאתם אחד כזה ברשימה, אין בעיה לקבל חדשים </p>
          <div className='bottom-div'>
            <a href='#' onClick={refreshPhones}>
              הציגו מספרים חדשים
            </a>
          </div>
        </div>
        {props.form.newPrettyPhones != '' && props.form.newPrettyPhones != undefined
          ? props.form.newPrettyPhones?.map(function (item, i) {
              return (
                <div>
                  <div key={i} className={props.form.selectedPhone != item ? 'phone-pretty-row' : 'phone-pretty-row bordered'}>
                    <div className='phone-pretty-content'>
                      <div className='phone-pretty-num'>
                        {props.form.selectedPhone != item ? (
                          <Image src={require('./images/star.svg')} alt='כוכב' className='list-top__icon' />
                        ) : (
                          <div className='heart'>
                            <Lottie options={{animationData: Heart, loop: false, resizeMode: 'cover'}} />
                          </div>
                        )}
                        <span className='phone-pretty-span'>{insertAt(item, '-', 3)}</span>
                      </div>
                      <div className='btn-holder'>
                        <div className='btn-additional-number'>
                          {props.form.selectedPhone != item ? (
                            <button onClick={(e) => handleSelected(item, true)} className='btn-additional-number__body unselected'>
                              <span className='btn-additional-number__text'>אהבתי</span>
                            </button>
                          ) : (
                            <button onClick={(e) => handleSelected(item, true)} className='btn-additional-number__body selected'>
                              <Image src={require('./images/icon-v-pink.svg')} alt='סימן V' className='' />
                            </button>
                          )}
                        </div>
                        <div className='under-btn-text'>{props.prettyNumbersUnderBtnText}</div>
                      </div>
                    </div>
                  </div>
                  <div className='thin-border'></div>
                </div>
              );
            })
          : null}

        {props.form.newPhones != '' && props.form.newPhones != undefined && !props.form.isExistPhone
          ? props.form.newPhones?.map(function (item, i) {
              return (
                <div className='phone-content'>
                  <div key={i} className='phone-row'>
                    <div className='phone-content'>
                      <div className='phone-num'>
                        <Image src={require('./images/mobile-black .svg')} alt='מספר טלפון' className='list-top__icon' />
                        <span className='phone-span'>{insertAt(item, '-', 3)}</span>
                      </div>
                      <div className='btn-additional-number'>
                        {props.form.selectedPhone != item ? (
                          <button onClick={(e) => handleSelected(item, false)} className='btn-additional-number__body unselected'>
                            <span className='btn-additional-number__text t-unselected'>אהבתי</span>
                          </button>
                        ) : (
                          <button onClick={(e) => handleSelected(item, false)} className='btn-additional-number__body selected'>
                            <Image src={require('./images/icon-v-pink.svg')} alt='סימן V' className='' />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {props.form.newPhones.length - 1 != i ? <div className='thin-border'></div> : ''}
                </div>
              );
            })
          : null}
        {props.form.errors.selectedPhone && <div className='error-msg'>{props.form.errors.selectedPhone}</div>}

        <div
          className={
            (isShowNewPhone === true,
            props.form.newPhones && props.form.newPhones.length > 0 && !props.form.isExistPhone ? 'footer-link' : 'hide-container')
          }>
          <span>שננסה שוב?</span>&nbsp;
          <a href='#' onClick={refreshPhones}>
            לחצו כאן למספרים חדשים
          </a>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    form: state.choseNewOrExistingCellNum.form,
    productsInfo: state.saleBlock.productsInfo,
    flowType: state.saleBlock.flowType,
    urlToChangePackage: state.saleBlock.epiServer.saleBlock.urlToChangePackage,
  };
};

const mapDispatchToProps = {
  setIsExistPhone,
  changeHandler,
  initData,
  getPhoneNumbers,
  showAppLoader,
  hideAppLoader,
  setSelectedPhone,
  setIsSelectedOption,
  addAttempt,
  validateExistPhone,
  validateNewPhones,
  initValidation,
  reportAnalytics,
  setPrettyNumData,
};

export default connect(mapStateToProps, mapDispatchToProps)(choseNewOrExistingCellNum);
